/* tslint:disable */
/* eslint-disable */
export enum JofiMembershipStatusEnum {
  Invited = 'INVITED',
  Accepted = 'ACCEPTED',
  Disabled = 'DISABLED'
}
